import type { IDeliveryProvider, DeliveryProviderRuntimeConfig } from './interfaces';
import { MockDeliveryProvider } from './mock/mock-provider';
import { IntigoProvider, type IntigoProviderConfig } from './intigo/intigo-provider';

/** Resolve a delivery provider implementation by code.
 *  Adapters are loaded eagerly for now. Future carriers slot in here. */
export function getDeliveryProvider(
  code: string,
  config?: DeliveryProviderRuntimeConfig & Partial<Pick<IntigoProviderConfig, 'getAccessToken'>>,
): IDeliveryProvider {
  switch (code) {
    case 'mock':
      return new MockDeliveryProvider(config);
    case 'intigo':
      if (!config?.getAccessToken) {
        throw new Error('intigo_provider_requires_getAccessToken');
      }
      return new IntigoProvider({
        apiKey: config.apiKey ?? null,
        webhookSecret: config.webhookSecret ?? null,
        proxyBaseUrl: config.proxyBaseUrl ?? '/api/delivery/intigo',
        businessId: config.businessId ?? null,
        getAccessToken: config.getAccessToken,
      });
    default:
      throw new Error(`Unknown delivery provider code: ${code}`);
  }
}

/** All provider codes the platform knows how to instantiate. */
export const SUPPORTED_DELIVERY_PROVIDER_CODES = ['mock', 'intigo'] as const;
export type SupportedDeliveryProviderCode = typeof SUPPORTED_DELIVERY_PROVIDER_CODES[number];
